import { CheckIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import type React from "react";
import { twMerge } from "tailwind-merge";

export type CheckCircleProps = {
  width?: number;
  height?: number;
  iconProps?: React.ComponentPropsWithoutRef<"svg">;
} & React.ComponentPropsWithoutRef<"div">;

export const CheckCircle = ({ width = 34, height = 32, iconProps, ...props }: CheckCircleProps) => (
  <div
    className={twMerge(
      "mr-4 flex items-center justify-center rounded-full bg-primary text-white",
      props.className
    )}
    style={{ width, height, ...props.style }}
    {..._.omit(props, "className", "style")}
  >
    <CheckIcon className="h-4 w-4" strokeWidth={iconProps?.strokeWidth ?? 3} {...iconProps} />
  </div>
);
